import $ from 'jquery';

const isRtl = document.documentElement.lang === 'ar';
$('.js-media-slider').slick({
  fade: true,
  infinite: true,
  mobileFirst: true,
  appendArrows: '.js-carousel-nav',
  prevArrow: $('.media-left'),
  nextArrow: $('.media-right'),
  rtl: isRtl
});

let isPlaying = false;
const stopAllYouTubeVideos = () => {
  const iframes = $('iframe');
  Array.prototype.forEach.call(iframes, (iframe) => {
    iframe.contentWindow.postMessage(JSON.stringify({
      event: 'command',
      func: 'stopVideo'
    }), '*');
  });
};

$('.js-media-slider').on('beforeChange', () => {
  stopAllYouTubeVideos();
  isPlaying = false;
});

const mediaSection = () => {
  const playButton = $('.js-play-button');
  playButton.click(function () {
    const mediaId = $(this).attr('data-id');
    const mediaVideo = $(`.media-video[data-id="${mediaId}"]`)[0];
    if (!isPlaying) {
      mediaVideo.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'playVideo'
      }), '*');
      if (isRtl) {
        $('.js-play-text').text('وقفة الفيديو');
      } else {
        $('.js-play-text')
          .text('Pause video');
      }
      isPlaying = true;
      return;
    }
    if (isPlaying) {
      mediaVideo.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'pauseVideo'
      }), '*');
      if (isRtl) {
        $('.js-play-text').text('شغل الفيديو');
      } else {
        $('.js-play-text')
          .text('Play video');
      }
      isPlaying = false;
    }
  });
};


export default () => {
  mediaSection();
};
